export default __webpack_public_path__ + "106ef6676c454826103cdad2ffe200d0.gif";